// extracted by mini-css-extract-plugin
export default {"menu":"A6Txu","scrolled":"NHDNT"};